import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-filter" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_MultiSelect, {
      "model-value": _ctx.modelValue,
      options: _ctx.items,
      optionLabel: (opt) => _ctx.categoryParams(opt).name,
      "option-value": "id",
      "data-key": "id",
      placeholder: _ctx.placeholder || _ctx.$t('rapport.byCategories'),
      filter: true,
      display: "chip",
      "filter-fields": ['label'],
      filterPlaceholder: _ctx.$t('search'),
      loading: _ctx.loading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, null, 8, ["model-value", "options", "optionLabel", "placeholder", "filterPlaceholder", "loading"])
  ]))
}